import React, { useContext } from 'react'
import { getMessage } from 'lib/translator'
import { LayoutContext } from 'pages/app-home/ManageLayout'
import { ModulesContext } from './ModulesProvider'
import { Searchable, Select } from 'components/Form'
import './style.css'

const LAYOUT_OPTIONS = [
  { text: 'Default', value: 'Default' },
  { text: 'ScanFairprice', value: 'ScanFairprice' },
  { text: 'ScanKopitiam', value: 'ScanKopitiam' },
  { text: 'ScanOmnistore', value: 'ScanOmnistore' },
]

const Navigator = () => {
  const {
    layout,
    segment,
    setLayout,
    setSegment,
    enableSegmentConfig,
    router,
    isDraft,
    setIsDraft,
  } = useContext(LayoutContext)
  const { updateModulePosition } = useContext(ModulesContext)
  const buttonsConfig = [
    {
      type: 'primary',
      label: getMessage('apphome.enable'),
      onClick: updateModulePosition,
      testId: 'publish-button',
    },
    {
      type: 'button',
      label: getMessage('apphome.cancel.draft'),
      onClick: () => {
        setLayout({ ...layout })
        setIsDraft(false)
      },
      testId: 'cancel-button',
    },
  ]

  return (
    <div className="selector-buttons-section">
      {!isDraft && (
        <div className="filter-section">
          <Select
            name="select-layout"
            placeholder={getMessage(
              'app.layout.module.selectLayout.placeholder'
            )}
            options={LAYOUT_OPTIONS}
            value={layout.name}
            onChange={(e) => {
              setLayout({ name: e })
              setSegment(null)
              router.history.replace(router.location.pathname)
            }}
          />
          {layout.name === 'Default' && enableSegmentConfig && (
            <Searchable
              readOnly={isDraft}
              placeholder={getMessage('app.layout.module.segment.placeholder')}
              transformResponse={(response) => response.data}
              searchUrl="/segments"
              searchKey="name"
              nameKey="name"
              valueKey="name"
              value={segment}
              onChange={(e) => {
                setSegment(e)
                if (e.name) {
                  router.history.replace(
                    `/app-home/dynamic-layout?segment=${e.name}`
                  )
                } else {
                  router.history.replace(router.location.pathname)
                }
              }}
            />
          )}
        </div>
      )}
      {isDraft && (
        <div className="buttons-section">
          {buttonsConfig.map((button) => (
            <button
              key={button.testId}
              type="button"
              className={button.type}
              onClick={button.onClick}
              data-testid={button.testId}
            >
              {button.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default Navigator
